module.exports = __webpack_public_path__ + "static/rcc-knb61-orr-graph-desktop-570469e28388d09719ab6135300f9b2e.png";